;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"6a5f790db9cc768ccf3ccd503a32fccbf9f850f5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import getConfig from 'next/config'
import * as Sentry from '@sentry/nextjs'

const { publicRuntimeConfig: config } = getConfig()

const dsn = config.sentryDsn
// in preview apps config.nodeEnv = 'production' but config.environment = 'preview'
const nodeEnv = config.nodeEnv
const environment = config.environment

if (dsn && nodeEnv === 'production') {
  Sentry.init({
    dsn,
    tracesSampleRate: 1.0,
    hideSourceMaps: false,
    environment: environment,
    release: 'kikin-app@' + config.vercelGitCommitSha,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
    ],
  })
}
